<template>
  <div v-if="$store.state.user.permissions.security_show" class="security">

    <BaseTable
        :settings="settings" 
        :fields="fields"
        :items="result"
        :searchTerm="$store.state.searchTerm"
        colstripes
        tableClass="tableSecurity"
        sortBy="right_desc"
        sortOrder="asc"
        tableId="1" /> 

  </div>
</template>

<script>
import EventBus from "../bus";
import BaseTable from "../components/table/_BaseTable";
import functions from '../mixins/functions';
export default {
  name: 'security',
  mixins: [functions],
  data () {
    return {
      result: [],
      settings: {},
      fields: []
    }
  },
  created: function (){
    this.resetBar()
    if(this.$store.state.user.permissions.security_add){
      this.$store.state.bar.add = true
    }
    this.$store.state.bar.search = true
  },
  mounted: function () {
    EventBus.$emit("checklogin")
    this.$store.state.heading = "Sicherheit - Berechtigungsgruppen"

    EventBus.$on("add", (item) => {
      if(item.length < 5){
        EventBus.$emit("showinfo", "info", "Neue Benutzergruppe sollte mindestens 5 Zeichen haben", 5) 
        return
      }
      let headers = {'Content-Type': 'application/json'}
      this.$http.post('/api/security.pl', {action: "setNewSecurityGroup", group_name: item}, {headers}).then(function (response) {
        if(response.data.status == 1){
          EventBus.$emit("resetMenuInput")
          this.init()
        }
        EventBus.$emit("showinfo", response.data.callmessage, response.data.message, response.data.timesecmessage)
        
      });
    });  

    EventBus.$on("changeSecurity", (item, h) => {
      var old_state = item[h.show]
      if(item[h.show] == 2){
        return;
      }
      item[h.show] = 2;
      var words = h.show.split('_');
      if(words.length < 2){
        return;
      }
      
      let headers = {'Content-Type': 'application/json'}
      this.$http.post('/api/security.pl', {action: "setSecurity", security_group_id : words[1], security_right_id: item.security_right_id}, {headers}).then(function (response) {
        var result = response.data
        if( result.status == 1 ){
          item[h.show] = response.data.new_state 
          EventBus.$emit("checklogin")
        }
        else if( result.status == 2 ){
          item[h.show] = old_state
          EventBus.$emit("showinfo", "error", response.data.error, 10) 
        }
        else{
          item[h.show] = old_state
          EventBus.$emit("showinfo", "error", "Es ist ein Fehler aufgetreten", 10)        
        }
      });
    });

    this.init()
     
  },
  methods:{
    init: function(){
      if(this.$store.state.user.permissions.security_add){
        this.$store.state.bar.menuinputplace = "Neue Benutzergruppe" 
      }
      this.$store.state.isLoading = true
      
      this.fields = [
        { label: "Berechtigungen / Gruppen", show: "right_desc", width: "300px", sort: "sort_group"},
        { label: "", show: "info", type: "info", sortable: false}
        ];

      let headers = {'Content-Type': 'application/json'}
      this.$http.post('/api/security.pl', {action: "getInit"}, {headers}).then(function (response) {
        var result = response.data
        if( result.status == 1 ){
          this.securityGroups = response.data.security_groups 
          
          var self = this;
          this.securityGroups.forEach(function(item) {
            self.fields.push( { 
              label: item.text, 
              show: "sg_" + item.value,
              classes: ["center", "nowrap", "button"],
              hclasses: ["rotate"],
              width: "60px",
              type: "check",
              event: "changeSecurity"
              } )
          });

          this.result = response.data.result
          this.$store.state.isLoading = false
        }
        else{
          EventBus.$emit("showinfo", "error", "Es ist ein Fehler aufgetreten bei dem Laden der Rechte Gruppen", 10)        
        }
      });
    }
  },
  components: {
    BaseTable
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Security.vue